<template>
  <div :class="classnames">
    <slot />
  </div>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'popup-control'

  export default {
    name: 'PopupControl',
    mixins: [ bem ],
    data: function () {
      return {}
    },
    created: function () {
      this.namespace = namespace
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/Popup/PopupControl.vue